import { render, staticRenderFns } from "./BeforeAfter.vue?vue&type=template&id=7dca9564&lang=pug&"
import script from "./BeforeAfter.vue?vue&type=script&lang=js&"
export * from "./BeforeAfter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dca9564')) {
      api.createRecord('7dca9564', component.options)
    } else {
      api.reload('7dca9564', component.options)
    }
    module.hot.accept("./BeforeAfter.vue?vue&type=template&id=7dca9564&lang=pug&", function () {
      api.rerender('7dca9564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/BeforeAfter.vue"
export default component.exports